const initialInsuranceMap = {
    insuranceMapPermissions:{},
    insuranceMapLists: [],
    insuranceMapStatus: [],
    changedInsuranceMapStatus : [],
    loadingInsuranceMap: false,
    errorsInsuranceMap: {}
}

const  insuranceMapReducer = (state = initialInsuranceMap, action) => {
    switch (action.type) {
        case "GET_INSURANCE_MAPPINGLIST_PENDING":
        case "ADD_INSURANCE_MAPPING_PENDING":
        case "UPDATE_INSURANCE_MAPPING_PENDING":
        case "UPDATE_INSURANCE_MAPPING_STATUS_PENDING":
        case "DELETE_INSURANCE_MAPPING_PENDING":
        case "GET_INSURANCE_MAPPINGLISTBYID_PENDING":
            return { ...state, loadingInsuranceMap: true };

        case "GET_INSURANCE_MAPPINGLIST_FULFILLED":
            return {
                ...state,
                loadingInsuranceMap: false,
                insuranceMapLists: action.payload,
                insuranceMapCount: action.insuranceMapCount,
                insuranceMapPermissions:action.permissions,
            };

        case "ADD_INSURANCE_MAPPING_FULFILLED":
            return {
                ...state,
                loadingInsuranceMap: false,
                changedInsuranceMapStatus: action.payload,
            };

        case "UPDATE_INSURANCE_MAPPING_FULFILLED":
            return {
                ...state,
                loadingInsuranceMap: false,
                changedInsuranceMapStatus: action.payload,
            };

        case "UPDATE_INSURANCE_MAPPING_STATUS_FULFILLED":
                return {
                    ...state,
                    loadingInsuranceMap: false,
                    changedInsuranceMapStatus: action.payload,
                };

        case "GET_INSURANCE_MAPPINGLISTBYID_FULFILLED":
            return {
                ...state,
                loadingInsuranceMap: false,
                insuranceMapLists: action.payload
            };

        case "DELETE_INSURANCE_MAPPING_FULFILLED":
            return {
                ...state,
                loadingInsuranceMap: false,
                changedInsuranceMapStatus: action.payload
            };

        case "RESET_DELETE_INSURANCE_MAPPING_STATUS":
            return {
                ...state,
                loadingInsuranceMap: false,
                changedInsuranceMapStatus: [],
                errorsInsuranceMap:{}
            };

        case "GET_INSURANCE_MAPPINGLIST_REJECTED":
        case "ADD_INSURANCE_MAPPING_REJECTED":
        case "UPDATE_INSURANCE_MAPPING_REJECTED":
        case "UPDATE_INSURANCE_MAPPING_STATUS_REJECTED":
        case "DELETE_INSURANCE_MAPPING_REJECTED":
        case "GET_INSURANCE_MAPPINGLISTBYID_REJECTED":
            return {
                ...state,
                loadingInsuranceMap: false,
                errorsInsuranceMap: action.payload
            };

        default:
            return state;
    }
}

export default insuranceMapReducer;